import React from 'react'
import ResendIcon from '@material-ui/icons/ReplyAllRounded'
import ReplaceTruckIcon from '@material-ui/icons/PlaylistAddCheckRounded'
import ToolTip from '../UI/ToolTip'
import { TwoLineItem, SingleItemBold } from '../UI/TableItem'
import { DriverDispatch } from './Types/types'
import RemoveTruckIcon from '@material-ui/icons/CloseRounded'
import moment from 'moment'

export type Props = {
  dispatchItem: DriverDispatch
  index: number
  sendDriverNotification: (dispatchId: string) => void
  handleReplaceTruckPress: (_id: string) => void
  handleCancelTruckPress: (_id: string) => void
}

const DispatchItem = ({
  dispatchItem,
  index,
  sendDriverNotification,
  handleReplaceTruckPress,
  handleCancelTruckPress
}: Props) => {
  const getStatusText = () => {
    switch (dispatchItem.status) {
      case 'accepted':
        return 'Accepted'
      case 'new':
        return 'Awaiting Reply'
      case 'declined':
        return 'Declined'
    }
  }

  const getItemColor = () => {
    switch (dispatchItem.status) {
      case 'accepted':
        return '#3BAD4B'
      case 'new':
        return '#FACF55'
      case 'declined':
        return '#F0535D'
    }
  }

  const getActionIcon = (_id: string) => {
    switch (dispatchItem.status) {
      case 'accepted':
        return
      case 'new':
        return (
          <>
            <ToolTip title="Resend Request">
              <ResendIcon
                className="actionsIcon"
                onClick={() => sendDriverNotification(dispatchItem.driverId)}
              />
            </ToolTip>
            <ToolTip title="Remove Truck">
              <RemoveTruckIcon
                className="actionsIcon"
                onClick={() => handleCancelTruckPress(dispatchItem._id)}
              />
            </ToolTip>
          </>
        )
      case 'declined':
        return (
          <ToolTip title="Replace Truck">
            <ReplaceTruckIcon
              className="actionsIcon"
              onClick={() => handleReplaceTruckPress(_id)}
            />
          </ToolTip>
        )
    }
  }

  const shouldRenderActions = moment().isBefore(moment(dispatchItem.startDateTime))
  // const shouldRenderActions = true

  return (
    <tr style={{ borderLeft: `5px solid ${getItemColor()}` }} className="tableRowHover" key={'x'}>
      <SingleItemBold text={getStatusText()} width="10" />
      <TwoLineItem
        text={dispatchItem.driverName ? dispatchItem.driverName : dispatchItem.driverPhoneNumber}
        subText={dispatchItem.driverCompanyName}
        width="15"
      />
      <SingleItemBold
        text={`${dispatchItem.truckType} ${
          dispatchItem.trailerType ? `with ${dispatchItem.trailerType}` : ''
        }`}
        width="10"
      />
      <TwoLineItem text="Teamsters" subText="Union" width="15" />
      <TwoLineItem text="N/A" subText="Driver Rating" width="15" />

      <td style={{ textAlign: 'right', width: '10%' }}>
        {shouldRenderActions && getActionIcon(dispatchItem._id)}
      </td>
    </tr>
  )
}

export default DispatchItem
